export function focusElement(id: string): void {
    const button = window.document.getElementById(id);
    if (button) {
        button.focus();
    }
}
